// src/pages/hr/HRAssets.jsx
import React from "react";
import HRComingSoon from "./HRComingSoon";

export default function HRAssets() {
  return (
    <HRComingSoon
      icon="💻"
      title="Asset Management"
      description="Track hardware inventory (laptops, monitors, devices), software licenses, asset assignments to employees, and return verification. Coming soon."
    />
  );
}
